import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { API_BASE_URL, APIBasePathInterceptor } from './interceptors/base-path.interceptor';
import { HOST_URL } from './services/api-host-url.token';

@NgModule()
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: HOST_URL, useValue: '' },
        { provide: API_BASE_URL, useValue: '' },
        { provide: HTTP_INTERCEPTORS, useClass: APIBasePathInterceptor, multi: true },
      ],
    };
  }
}
